// Texty výpisu rubriky blogu — slovenské dvojče locale/cs/articlesPage.js.
// Blog na SK neexistuje (0 článkov), dvojča je tu kvôli zhode tvaru.
export default {
  lead: 'Najnovšie',
  leadCta: 'Prečítať článok',
  more: 'Čítať ďalej',
  rubrics: 'Rubriky',
  latest: 'Najnovšie v rubrike',
  prev: 'Predchádzajúca strana',
  next: 'Ďalšia strana',
  pagerLabel: 'Stránkovanie článkov',
  pageOf: (page, pages) => 'Strana ' + page + ' z ' + pages,
  newsletterEyebrow: 'Newsletter',
  newsletterTitle: 'Tipy do dielne raz mesačne',
  newsletterText: 'Nové články, sezónne rady a akcie skôr než na webe. Odhlásite sa jedným kliknutím.',
  newsletterCta: 'Odoberať novinky',
  newsletterSubmit: 'Odoberať',
  // SK: neověřeno ve fixtures (blog na SK neexistuje, e-mailový placeholder je odhad)
  newsletterPlaceholder: 'vas@email.sk',
  newsletterLabel: 'Váš e-mail',
};
